import * as types from './types'

export const setBeCdnLoaded = data => ({
  type: types.BE_CDN_LOADED,
  data
})
